import type { ReactNode } from 'react';
import { RedesignShell } from './redesign/RedesignShell';

interface MarketingPageShellProps {
  children: ReactNode;
  navActive?: React.ComponentProps<typeof RedesignShell>['navActive'];
}

export function MarketingPageShell({ children, navActive }: MarketingPageShellProps) {
  return <RedesignShell navActive={navActive}>{children}</RedesignShell>;
}
